export const useSleep = () => (ms) =>
  new Promise((res) => {
    setTimeout(() => {
      res();
    }, ms);
  });